<template>
  <!-- Modal Solicitar Cotización -->
  <div
    class="modal fade"
    id="cotizModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="cotizModal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" v-html="$t('cotizar.titulo_cotizar')"></h5>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Cerrar"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body modal-only-text">
          <img src="/img/calc.png" />
          <p>
            {{ $t("cotizar.haz_seleccionado") }}
            <strong>{{
              $tc("cotizar.cant_espacios", cant_espacios, {
                count: cant_espacios,
              })
            }}</strong>
            {{ $t("cotizar.para_cotizar") }}
          </p>

          <form
            class="form-signin form-regist"
            v-on:submit.prevent="sendForm()"
            data-vv-scope="form_cotizacion"
          >
            <input
              type="text"
              id="typeProduct"
              class="form-control"
              placeholder="¿Qué tipo de producto deseas anunciar?"
              name="typeProduct"
              autofocus
              v-validate="'required'"
              v-model="typeProduct"
            />
            <span
              class="error text-danger"
              v-show="errors_validate.has('form_cotizacion.typeProduct')"
              >{{ $t('required') }}</span
            >

            <p class="mb-4">
              Así podemos recomendarte las mejores ubicaciones.
            </p>

            <textarea
              class="form-control"
              v-model="coment"
              id="inputComment"
              rows="3"
              :placeholder="$t('cotizar.algun_coment')"
            ></textarea>

            <div class="col-md-12 cont-captcha">
              <!-- <vue-recaptcha
                ref="invisibleRecaptcha3"
                :sitekey="sit_ky"
                :loadRecaptchaScript="true"
                recaptchaScriptId="invisibleRecaptcha3"
                size="invisible"
                @verify="onCaptchaVerified"
                @expired="onExpired"
              ></vue-recaptcha> -->
            </div>
            <div class="cont_loader">
              <vue-loading
                type="spin"
                color="#d9544e"
                :size="{ width: '30px', height: '30px' }"
                v-show="validando_captcha"
              ></vue-loading>
            </div>
            <div class="bt-signin-box">
              <button
                class="material-btn bt_red"
                type="submit"
                :disabled="validando_captcha"
                v-html="$t('boton.enviar')"
              ></button>
            </div>
          </form>

          <!-- <p>Estaremos procesando la solicitud con brevedad.</p>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Snackbar from "node-snackbar";
import { mapActions, mapGetters } from "vuex";

import * as cotizacionRequest from "../../request/cotizacion.js";
import * as usage_request from "../../request/usage.js";
import * as AuthRequest from "../../request/auth.js";

import AuthMixins from "../../mixins/auth.js";

export default {
  props: [
    "cant_espacios",
    "locations",
    "grupos",
    "lista_espacios",
    "validateRecaptcha",
    "resetTheRecaptcha",
  ],
  mixins: [AuthMixins],
  mounted() {
    let vm = this;
    $(document).ready(function () {
      $("#cotizModal").on("show.bs.modal", function (e) {
        document.getElementById("app").style.position = "relative";
      });
      $("#cotizModal").on("hidden.bs.modal", function () {
        document.getElementById("app").style.position = "fixed";
      });
    });

    AuthRequest.getIpInfo()
      .then((response) => {
        vm.ipInfo = response.data;
        vm.country = response.data.country;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  data() {
    return {
      coment: "",
      date: null,
      duration: null,
      typeProduct: null,
      url_api: window.url_api,
      sit_ky: process.env.VUE_APP_RECAPTH_KEY_PROD,
      currency_type: "RD",
      country: "DO",
    };
  },
  computed: {
    ...mapGetters(["getUser", "getToken"]),
  },
  methods: {
    ...mapActions(["changueUser", "changueToken", "logout"]),

    // envia el formulario al servidor y luego habre el modal de confirmacion de envio...
    sendForm() {
      this.$validator.validateAll("form_cotizacion").then((result) => {
        if (result) {
          this.validando_captcha = true;
          this.validateRecaptcha("Quote");
        }
      });
    },
    onCaptchaVerified(token) {
      let vm = this;

      this.getDataMenu();
      let data = new FormData();
      let advertising = {
        customer_id: 2,
        answered: 0,
        advertising_start_date: this.date,
        duration: this.duration,
        comments: this.coment,
        categ_anunciante: this.typeProduct,
      };

      for (const key in advertising) {
        if (advertising.hasOwnProperty(key)) {
          data.append(key, advertising[key]);
        }
      }

      advertising.customer_id = this.getUser.id;

      let billboards = [];
      this.lista_espacios.map((item) => {
        item.vallas.map((valla, indice) => {
          // Usage Unit: requested

          if (
            this.$i18n.locale === "es" &&
            item.country_code &&
            item.country_code !== "DO"
          ) {
            vm.currency_type = "LAT-US";
          } else {
            vm.currency_type = "RD";
          }

          billboards.push({ id: indice, billboard_id: valla.id });
        });
      });
      usage_request.group({
        billboards: billboards,
        requested: 1,
      });

      if (this.$i18n.locale === "en") {
        this.currency_type = "US";
      } else {
        if (this.country !== "DO" && this.$i18n.locale === "es") {
          this.currency_type = "LAT-US";
        }
      }

      data.append("billboards", JSON.stringify(billboards));
      data.append("currency_type", this.currency_type);
      data.append("g-recaptcha-response", token);

      if (this.date) {
        cotizacionRequest
          .create(data)
          .then((response) => {
            if (response.data.success) {
              $("#cotizModal").modal("hide");
              vm.validando_captcha = false;
              setTimeout(() => {
                $("body").removeClass("modal-open");
                $(".modal-backdrop").remove();
              }, 500);
              setTimeout(() => {
                $("#confirmCotizModal").modal("show");
                vm.$parent.$refs.side_menu.resetData();
                vm.coment = "";
              }, 1000);
              setTimeout(() => {
                $("#confirmCotizModal").modal("hide");
              }, 7000);
            } else {
              //  $('#confirmCotizModal').modal('show');
            }
          })
          .catch((err_) => {
            console.log(err_);
            if (err_.response.status === 401) {
              vm.logout();
              $("#cotizModal").modal("hide");
              vm.validando_captcha = false;
              vm.coment = "";
              setTimeout(() => {
                $("body").removeClass("modal-open");
                $(".modal-backdrop").remove();
              }, 500);
              setTimeout(() => {
                $("#loginModal").modal("show");
              }, 800);
            } else {
              Snackbar.show({
                text: "Ha ocurrido un error. Inténtalo de nuevo o contacta a Soporte al Cliente.",
                pos: "bottom-center",
                backgroundColor: "#ff1744",
                actionText: "<b>Cerrar</b>",
                actionTextColor: "#fff",
              });
            }
          });
      } else {
        Snackbar.show({
          text: "Debes selecionar una fecha de inicio.",
          pos: "bottom-center",
          backgroundColor: "#ff1744",
          actionText: "<b>Cerrar</b>",
          actionTextColor: "#fff",
        });
      }
    },
    // obtiene los datos del menu derecho
    getDataMenu() {
      let result = this.$parent.$refs.side_menu.returnData();
      if (result) {
        this.date = result.date;
        this.duration = result.duration;
      }
      return result;
    },
  },
};
</script>

<i18n src="@/locale/modals/generic.json" />
<i18n src="@/locale/modals/mensajes.json" />
